// Auto-generated from container.json
export default {
  "uiType": "element",
  "name": "Container",
  "description": "A container limits content to a maximum width",
  "tagName": "ui-container",
  "exportName": "UIContainer",
  "content": [],
  "types": [],
  "variations": [],
  "events": [],
  "settings": []
};
